import { checkRangeByKeys, getRangeByKeys } from '../../ui-kit/Calculator/rangeHelpers.js';
import { arrayByRange } from '../../utils/arrayByRange.js';
import { mergeIntervals } from '../../utils/mergeIntervals.js';
const DEFAULT_DEPOSIT_CALCULATOR_PARAMS = {
    minSum: 50000,
    maxSum: 100000001,
    minMonths: 2,
    maxMonths: 10,
    rate: 0,
    isMonthlyInterestPayment: true,
    isRemoteRegistration: true,
    isReplenish: false,
    isWithdrawn: false,
    type: '',
};
export const getDepositCalculatorParams = (userInputParams, rows, paramsViewSettings) => {
    const { moneyValue, monthsValue } = userInputParams;
    const defaultMonth = rows?.[0] ? getMiddleMonth(rows[0].minMonths, rows[0].maxMonths) : 0;
    const isExcludeMonthlyInterestPayment = !paramsViewSettings?.isShowMonthlyInterestPayment;
    const isExcludeRemoteRegistration = !paramsViewSettings?.isShowRemoteRegistration;
    const isExcludeReplenish = !paramsViewSettings?.isShowReplenish;
    const isExcludeWithdrawn = !paramsViewSettings?.isShowWithdrawn;
    const isExcludeNewClient = !paramsViewSettings?.isShowNewClient;
    const depositCalculatorSourceBookParams = rows?.find((row) => [
        checkRowByParam({
            row,
            userInputParams,
            paramKey: 'isReplenish',
            isExclude: isExcludeReplenish,
        }),
        checkRowByParam({
            row,
            userInputParams,
            paramKey: 'isWithdrawn',
            isExclude: isExcludeWithdrawn,
        }),
        checkRowByParam({
            row,
            userInputParams,
            paramKey: 'isMonthlyInterestPayment',
            isExclude: isExcludeMonthlyInterestPayment,
        }),
        checkRowByParam({
            row,
            userInputParams,
            paramKey: 'isRemoteRegistration',
            isExclude: isExcludeRemoteRegistration,
        }),
        isExcludeNewClient || userInputParams?.['isNewClient'] === row?.['isNewClient'],
        checkRangeByKeys(moneyValue, ['minSum', 'maxSum'], row),
        checkRangeByKeys(monthsValue || defaultMonth, ['minMonths', 'maxMonths'], row),
    ].every(Boolean)) || DEFAULT_DEPOSIT_CALCULATOR_PARAMS;
    const { rate } = depositCalculatorSourceBookParams;
    const income = getDepositIncome(rate, userInputParams);
    const finalSum = moneyValue + income;
    const sourceBookRows = rows || [DEFAULT_DEPOSIT_CALCULATOR_PARAMS];
    return {
        ...depositCalculatorSourceBookParams,
        ...getRangeByKeys(['minSum', 'maxSum'], sourceBookRows),
        ...getRangeByKeys(['minMonths', 'maxMonths'], sourceBookRows),
        availableMonths: mergeIntervals(sourceBookRows.map((row) => [row['minMonths'], row['maxMonths']])).flatMap(([start, end]) => arrayByRange(start, end)),
        ...userInputParams,
        defaultMonth,
        income,
        finalSum,
    };
};
const getDepositIncome = (rate, userInputParams) => {
    const { isMonthlyInterestPayment, moneyValue, monthsValue } = userInputParams;
    if (isMonthlyInterestPayment) {
        return Math.round(moneyValue * Math.pow((1200 + rate) / 1200, monthsValue) - moneyValue);
    }
    else {
        /*
        Приблизительный расчёт, не учитывающий разницу в количестве дней в месяцах. Месяц принят за 30 дней, год за 365 дней.
        */
        return Math.round((moneyValue * rate * 30 * monthsValue) / 365 / 100);
    }
};
const checkRowByParam = ({ row, userInputParams, paramKey, isExclude }) => isExclude || userInputParams[paramKey] === row[paramKey];
const getMiddleMonth = (minMonths, maxMonths) => minMonths + Math.round((maxMonths - minMonths) / 2);
//# sourceMappingURL=getDepositCalculatorParams.js.map